import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { DepletionTypeService } from '../proxy/controlling/controllers/depletion-type.service';
import { AssetService } from '../proxy/controlling/controllers/asset.service';
import { RegionService, PropertyService } from '@planning/proxy/planning/controllers';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEASSET_FIELDS: FieldDefinition[] = [
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('regionId', 'Entity.ContractTypeAsset.Region', RegionService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('propertyId', 'Entity.ContractTypeAsset.Property', PropertyService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('isOwnPlantation', 'Entity.ContractTypeAsset.IsOwnPlantation')
    .build(),
  FieldBuilder.foreignKey(
    'contractTypeId',
    'Entity.ContractTypeAsset.ContractType',
    ContractTypeService
  )
    .required()
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .build(),
  FieldBuilder.foreignKey(
    'depletionTypeId',
    'Entity.ContractTypeAsset.DepletionType',
    DepletionTypeService
  )
    .required()
    .displayFromNested('depletionType.name')
    .sortBy('depletionType.name')
    .build(),
   FieldBuilder.foreignKey(
     'assetId',
     'Entity.Asset',
     AssetService
   )
     .required()
     .displayFromNested('asset.name')
     .sortBy('asset.name')
     .build(),
];

export const CONTRACTTYPEASSET_CONFIG = {
  entityName: 'ContractTypeAsset',
  localizationKey: 'Controlling::Entity.ContractTypeAsset',
  fields: CONTRACTTYPEASSET_FIELDS,
  permission: 'ControllingContract.ContractTypeAssets',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
